'use client';

import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { useModal } from 'components/shared/Modal';
import { TypeformSnippet } from 'components/shared/TypeformSnippet';
import { CaretUpBlack } from '../../assets/icons';
import styles from './BottomBar.module.css';

export const SCROLLED_TRIGGERED_AFTER_VH_MULTIPLIER = 0.8;

export const BookCallTFComponentDiv = ({
  trackingParams,
}: {
  trackingParams?: {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
  };
}) => {
  const t = useTranslations('home');
  return (
    <div className={styles.bookCall}>
      <TypeformSnippet
        typeformId="yOi1E7Wy"
        frameTitle={t('home.bottomBar.label.bookCallTitle')}
        className={styles.typeformContainer}
        trackingParams={trackingParams}
      />
    </div>
  );
};

export const BottomBar = ({
  rightPadding,
  initialActive,
}: {
  rightPadding?: boolean;
  initialActive?: boolean;
}) => {
  const t = useTranslations('home');
  const ModalClient = useModal();
  const [isScrolled, setScrolled] = useState(false);

  const showBookCallModal = () => {
    ModalClient.set(<BookCallTFComponentDiv />);
    ModalClient.setCloseButtonTheme('light');
    ModalClient.show();
  };

  useEffect(() => {
    if (initialActive) {
      setScrolled(true);
      return;
    }

    if (!window) return;
    const SCROLLED_TRIGGERED_AFTER =
      SCROLLED_TRIGGERED_AFTER_VH_MULTIPLIER * window.innerHeight;
    setScrolled(window.scrollY > SCROLLED_TRIGGERED_AFTER);
    let ticking = false;

    const listener = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrolled(window.scrollY > SCROLLED_TRIGGERED_AFTER);
          ticking = false;
        });
        ticking = true;
      }
    };
    document.addEventListener('scroll', listener, { passive: true });
    return () => {
      document.removeEventListener('scroll', listener);
    };
  }, [initialActive]);

  return (
    <>
      <div
        className={`${styles.root}${isScrolled ? ` ${styles.active}` : ''} ${
          rightPadding ? styles.rightPadded : ''
        }`}
        onClick={showBookCallModal}
        role="button"
        tabIndex={0}
        onKeyDown={showBookCallModal}
      >
        <div className={styles.content}>
          {t('home.bottomBar.text.getRightPlan')}
          <span className={styles.subContent}>
            {t('home.bottomBar.button.talkToSpecialist')}
            <CaretUpBlack style={{ transform: 'rotate(90deg)' }} />
          </span>
        </div>
      </div>
    </>
  );
};
